import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList } from '@/api/system/user/user';
import { fetchList as DeveiceList } from '@/api/system/device/device';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      rules: {
        itemName: [{
          required: true,
          message: '请输入报名内容',
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: '长度在 1 到 100 个字符',
          trigger: 'change'
        }],
        itemPrice: [{
          required: true,
          message: '请输入价格',
          trigger: 'blur'
        }],
        itemOrder: [{
          required: true,
          message: '请输入排序',
          trigger: 'blur'
        }],
        totalNumber: [{
          required: true,
          message: '请输入最大报名人数',
          trigger: 'blur'
        }],
        checkNum: [{
          required: true,
          message: '请输入核销次数',
          trigger: 'blur'
        }],
        validPeriod: [{
          required: true,
          message: '请输入有效期',
          trigger: 'blur'
        }],
        deviceId: [{
          required: true,
          message: '请选择设备',
          trigger: 'changes'
        }]
      },
      childData: {
        itemName: ''
      },
      userOptions: [],
      deviceOption: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        // this.$refs.dataForm.resetFields()
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    getDeviceList: function getDeviceList() {
      var _this = this;

      DeveiceList({
        sysType: 'TFCS'
      }).then(function (response) {
        _this.deviceOption = response.data.data;
      });
    },
    getUseName: function getUseName() {
      var _this2 = this;

      this.userOptions.forEach(function (element) {
        if (element.userId == _this2.childData.coachId) {
          _this2.childData.coachName = element.userName;
        }
      });
    },
    getUser: function getUser() {
      var _this3 = this;

      fetchList({
        userState: 0,
        posId: 1773
      }).then(function (res) {
        _this3.userOptions = res.data.data;
      });
    },
    init: function init() {
      // this.$nextTick(() => {
      //     this.$refs['dataForm'].clearValidate()
      // })
      this.getUser();
      this.getDeviceList();

      if (this.keyValue != null) {
        this.childData = JSON.parse(JSON.stringify(this.keyValue));
      } else {
        this.childData = {
          checkNum: 1
        };
      }
    },
    handCreate: function handCreate() {
      var _this4 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this4.$emit('handCancle', true, _this4.childData);
        } else {
          _this4.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false, null);
    }
  }
};